import * as React from "react";
import { useEffect } from "react";
import { styled } from "@mui/material";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { ClinicQrCode } from "./clinicQrCode";
import { PatientColorMap } from "../../layout/patientColorMap";
import { useClinicShortCode } from "../../clinic/clinicHooks";
import { useTranslate } from "../../hooks/useTranslate";
import { usePatientFeatureFlags } from "../../hooks/usePatientFeatureFlags";
import { useWidgetSettings } from "../../widget/useWidgetSettings";

//region [[ Styles ]]

const ClinicCodeView = styled("div")({
  position: "relative",
  margin: "0 36px 18px",
  padding: "20px 20px",
  borderRadius: "5px",
  backgroundColor: PatientColorMap.Unselected,
  color: "black",
  fontSize: "36px",
  fontWeight: "bolder",
  letterSpacing: "0.4em",
  textAlign: "center",
});

const BottomText = styled("div")({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  margin: "15px 0",
  textAlign: "center",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicCodeProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicCode = ({ ...props }: ClinicCodeProps) => {
  const { clinicShortCode, makeCodeForCurrentSession } = useClinicShortCode();
  const { nonPersist } = useWidgetSettings();

  useEffect(() => {
    if (clinicShortCode?.loading || clinicShortCode?.current || nonPersist)
      return;
    makeCodeForCurrentSession().catch((e) => console.error(e));
  }, [clinicShortCode, makeCodeForCurrentSession, nonPersist]);

  const { translate } = useTranslate();
  const showQrCode = usePatientFeatureFlags("clinicQrCode");

  if (!clinicShortCode) return null;

  return (
    <>
      <ClinicCodeView>
        {clinicShortCode.loading ? (
          <ThreeDotsLoader color={PatientColorMap.Primary} />
        ) : (
          clinicShortCode.current || "------"
        )}
      </ClinicCodeView>
      {showQrCode && (
        <ClinicQrCode
          value={clinicShortCode.current}
          loading={clinicShortCode.loading}
        />
      )}
      <BottomText>{translate("SAVE_YOUR_SESSION_NUMBER")}</BottomText>
    </>
  );
};
